import React, { lazy, Suspense, useEffect, useState } from "react";
import "@fontsource/poppins";
import "../src/App.css";
import Header from "./components/Header";
import Body from "./components/Body/Body";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import jsonData from "./components/ai-branding.json"; // Import the JSON file
import { CookieSetting } from "cookiesetting-component";

const Footer = lazy(() => import("./components/FooterNew/index.js"));
const Trueapprove = lazy(() =>
  import("./components/Trueapprove/Trueapprove.js")
);
const Whysunwest = lazy(() => import("./components/Whysunwest/Morganscan.js"));
const Joaquin = lazy(() => import("./components/Joaquin/Joaquin.js"));

export default function App(setShowModal, setLoanOfficerUid, setLoanPurpose) {
  const [bannerData, setBannerData] = useState();

  const isProduction = process.env.NODE_ENV === "production";
  const appVersion = appversion.version;
  const [links, setLinks] = useState(null); // Set initial state as null

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const timestamp = Date.now(); // Generate a unique timestamp
        const url = `${process.env.REACT_APP_ANGELAI_JSON}?timestamp=${timestamp}`;
        const response = await axios.get(url);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);

  return (
    <CacheBuster
      currentVersion={appVersion}
      isEnabled={isProduction} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      // loadingComponent={<Loading />} //If not pass, nothing appears at the time of new version check.
      metaFileDirectory={"."} //If public assets are hosted somewhere other than root on your server.
    >
      <div className="bodyContainer">
        <Header fetchpriority="high" />
        {/* <Navbar /> */}
        <>
          <Body/>

          
          <Suspense fallback={<div />}>
            <Trueapprove links = {links} />
          </Suspense>
          <Suspense fallback={<div />}>
            <Whysunwest />
          </Suspense>
          <Suspense fallback={<div />}>
            <Joaquin />
          </Suspense>
          <Suspense fallback={<div />}>
            <Footer />
          </Suspense>
          <CookieSetting
          privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK}
          configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
          analytics={process.env.REACT_APP_ANALYTICS_PATH}
          />
        </>
      </div>
    </CacheBuster>
  );
}
